import AnamnesisView, { Views as ANAMNESIS_VIEWS } from 'components/organisms/Anamnesis';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import { getIsAuthenticated } from 'store/login';
import { actionCreators } from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { WithRouterType } from 'types/withRouter';
import { mapParentStateToProps } from '../Anamnesis';

const mapStateToProps = (state: IRootState, props: WithRouterType) => ({
	...mapParentStateToProps(state, props),
	isAuthenticated: getIsAuthenticated(state),
	currentStep: ANAMNESIS_VIEWS.START,
	// because https://inside.namics.com/display/TAFrontend/questions/520323125/answers/520716431
	title: undefined,
	introTitle: undefined,
	introText: undefined,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export type StartContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnamnesisView) as any);
